import { ICronGeneratorState } from './cronGeneratorContext';
import { CronGeneratorActionTypes, TCronGeneratorAction } from './cronGeneratorActions';

export const cronGeneratorReducer = (state: ICronGeneratorState, action: TCronGeneratorAction): ICronGeneratorState => {
	switch (action.type) {
		case CronGeneratorActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case CronGeneratorActionTypes.SET_FIELD_VALUE:
			return {
				...state,
				[action.payload.fieldName]: action.payload.value,
			};
		default:
			return state;
	}
};
